import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import {
  Button,
  DatePicker,
  Form,
  Input,
  Modal,
  Upload } from 'antd';

import dayjs from 'dayjs';
import { withTranslation } from 'react-i18next';

import * as ArrayUtils from '@utils/array';
import {
  UploadOutlined,
} from '@ant-design/icons';


const RESET_STATE = (state = {}) => {
  return {
    fileList: [],
    ...state,
  };
}

class UpdateForm extends React.Component {
  static propTypes = {
    visible: PropTypes.bool,
    confirmLoading: PropTypes.bool,
    onCancel: PropTypes.func.isRequired,
    onOk: PropTypes.func.isRequired,
  }

  static defaultProps = {
    visible: false,
    confirmLoading: false,
  }

  constructor(props) {
    super(props);
    this.state = RESET_STATE();
    this.onOk = this.onOk.bind(this);
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevProps.visible && !this.props.visible) {
      this.props.form.resetFields();
      this.setState(RESET_STATE());
      return
    }
  }

  normFile(e) {
    if (Array.isArray(e)) {
      return e;
    }
    return e && e.fileList;
  }


  onOk() {
    const { fileList } = this.state;
    this.props.form.setFieldsValue({
      br_file: (fileList.length > 0) ? fileList[0] : null,
    })
    this.props.onOk();
  }

  renderForm(owner) {
    const formItemLayout = {
      labelCol: { span: 9 },
      wrapperCol: { span: 14, offset: 1 },
    };

    const items = [
      {
        label: this.props.t("Owners.OwnerName"),
        shouldRender: true,
        render: () => owner.name,
      }, {
        label: this.props.t("Owners.OwnerType"),
        shouldRender: true,
        render: () => owner.is_company ? this.props.t("Owners.Company") : this.props.t("Owners.Individual"),
      }, {
        label: this.props.t("Owners.BRNumber"),
        name: "br_cert_number",
        shouldRender: owner.is_company,
        render: () => <Input placeholder={ this.props.t("Owners.BRNumber") } />,
      }, {
        label: this.props.t("Owners.BRExpiryDate"),
        name: "br_expiry_date",
        shouldRender: owner.is_company,
        render: () => <DatePicker format={"YYYY/MM/DD"} />,
      }, {
        label: this.props.t("Owners.IDNumber"),
        name: "id_card_number",
        shouldRender: !owner.is_company,
        render: () => <Input placeholder={ this.props.t("Owners.IDNumber") } />,
      }, {
        label: this.props.t("Owners.CorrespondenceAddress"),
        name: "correspondence_address",
        shouldRender: true,
        render: () => <Input.TextArea rows={ 4 } placeholder={ this.props.t("Owners.CorrespondenceAddress") } />,
      }, {
        label: this.props.t("shared.ContactDetails"),
        name: "contact_details",
        shouldRender: true,
        render: () => <Input.TextArea rows={ 4 } placeholder="Contact Details" />,
      }, {
        label: this.props.t("Owners.BusinessRegistration"),
        shouldRender: owner.is_company,
        render: () => (
          <div className="dropbox">
            <Upload
                multiple={ false }
                onRemove={
                  (file) => {
                    this.setState({ fileList: [] });
                  }
                }
                beforeUpload={
                  (file) => {
                    this.setState(state => ({
                      fileList: [file],
                    }));
                    return false;
                  }
                }
                fileList={ this.state.fileList }
                name="br_file"
              >
                <Button>
                  <UploadOutlined/> { this.props.t("actions.ClickToUpload") }
                </Button>
              </Upload>
          </div>
        ),
      }
    ]

    return (
      <Form form={this.props.form} layout="horizontal">
        {
          items.filter(({ shouldRender }) => shouldRender).map((item, index) => (
            <Form.Item
              key={ index.toString() }
              label={ item.label }
              name={ item.name }
              style={{ margin: 0, paddingBottom: 14 }}
              {...formItemLayout}
            >
              { item.render() }
            </Form.Item>
          ))
        }
      </Form>
    )
  }

  render() {
    if (!this.props.owner) {
      return null
    }
    return (
      <Modal
        visible={ this.props.visible }
        title={ this.props.t("Owners.actions.UpdateOwner") }
        okText={ this.props.t("actions.Submit") }
        onCancel={ this.props.onCancel }
        onOk={ this.onOk }
        confirmLoading={ this.props.confirmLoading }
      >
        { this.renderForm(this.props.owner) }
      </Modal>
    )
  }
}

const mapStateToProps = (state, props) => {
  return {};
}

const mapDispatchToProps = (dispatch, props) => {
  return {
  };
}

const ConnectedUpdateOwnerForm = connect(mapStateToProps, mapDispatchToProps)(UpdateForm);

const WrappedUpdateOwnerForm = (props) => {
  const [form] = Form.useForm();
  const { formRef, ...restProps } = props;
  if (formRef) formRef(form);
  return <ConnectedUpdateOwnerForm {...restProps} form={form} />;
};
export default withTranslation('common')(WrappedUpdateOwnerForm);
